<template>
  <b-container>
    <b-modal id="modal-upload" :title="this.modalTitle" @ok="onSubmit" ok-title="Upload" @hide="onHide">
      <b-overlay :show="showOverlay">
        <form ref="form">
          <!-- Chapter field -->
          <b-form-group id="chapter-fld-grp" label="Select a chapter" label-for="chapter-fld" v-if="this.uploadOptionProp === 'toWebtoon'"> 
            <b-form-select
              id="chapter-fld"
              v-model="selected" 
              :options="options"
            ></b-form-select>
            <b-form-input
              v-if="selected == 'New Chapter'"
              id="new-chapter-num-fld"
              v-model="newChapterNum"
              type="number"
              placeholder="Enter number"
            ></b-form-input>
            <b-form-input
              v-if="selected == 'New Chapter'"
              id="new-chapter-title-fld"
              v-model="newChapterTitle"
              placeholder="Enter new chapter's title"
            ></b-form-input>
          </b-form-group>
          <!-- Banner field -->
          <b-form-group id="banner-fld-grp" label="Select the banner for this chapter" label-for="banner-fld" v-if="this.uploadOptionProp === 'toWebtoon' && selected == 'New Chapter'">
            <b-dropdown id="bannerSelect" text="Select Banner" v-model="selectedBanner" variant="secondary">
              <b-dropdown-item @click="selectedBanner = 'New Banner'">New Banner</b-dropdown-item>
              <b-dropdown-item v-for="banner in this.optionsBanner" :key="banner.name" :value="banner.name" @click="selectedBanner = banner.imgUrl; selectedBannerLabel = banner.name">
                <span>{{banner.name}}</span>
                <br>
                <img class="bannerSelectOption" :src="`${banner.imgUrl}`">
              </b-dropdown-item>
            </b-dropdown>
            <span v-if="selectedBanner != 'New Banner'">Selected Banner: <img class="bannerSelectOption" :src="`${this.selectedBanner}`" alt="selected"></span>
            <b-form-input v-if="selectedBanner == 'New Banner'" id="new-banner-label" v-model="newBannerLabel" placeholder="Banner Label">
            </b-form-input>
            <b-form-file
              id="banner-file-fld"
              v-model="newBannerFile"
              :state="bannerFileChecker()"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ref="pageForm"
              accept = ".jpg, .png"
              v-if="selectedBanner == 'New Banner'"
            >
            </b-form-file>
            <b-form-invalid-feedback :state="bannerFileChecker()" v-if="selectedBanner == 'New Banner'">
              {{ bannerErrorMessage() }}
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- File field -->
          <b-form-group id="file-fld-grp" label="Select a file" label-for="file-fld"> 
            <b-form-file
              id="file-fld"
              v-model="file"
              :state="fileChecker()"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ref="pageForm"
              accept = ".jpg, .png"
            >
            </b-form-file>
            <b-form-invalid-feedback :state="fileChecker()">
              {{ errorMessage() }}
            </b-form-invalid-feedback>
          </b-form-group> 
          <!-- Tags field -->
          <b-form-group id="tags-fld-grp" v-if="this.uploadOptionProp === 'toGallery'">
            <label for="tags-fld">Type a new tag and press enter</label>
            <b-form-tags input-id="tags-fld" v-model="tags"></b-form-tags>
          </b-form-group>
          <!-- Email notif field -->
          <b-form-group id="notify">
            <b-form-checkbox
              id="notify-checkbox"
              v-model="notify"
              name="checkbox-1"
            >Notify subscribers
            </b-form-checkbox>
            <label for="notify-subject">Email subject:</label>
            <b-form-input
              id="notify-subject"
              v-model="notifyHeader"
              placeholder="Email subject"
              :disabled="notify == false"
            ></b-form-input>
            <label for="notify=message">Email body:</label>
            <b-form-textarea
              id="notify-message"
              v-model="notifyMessage"
              placeholder="A new page has been uploaded!"
              :disabled="notify == false"
              rows="3"
            ></b-form-textarea>
          </b-form-group>
        </form>    
        <!-- set custom overlay content -->
        <template v-slot:overlay>
          <div class="text-center">
            <p>{{uploadProgress}}</p>
            <!-- if progress value reaches 100, show this -->
            <p v-if="progress == 100">Upload Complete!</p>
          </div>
        </template>
      </b-overlay>
      <template v-slot:modal-footer="{ cancel, ok }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()" :disabled='!(uploadBtnChecker)'>
          Upload
        </b-button>
      </template> 
    </b-modal>
  </b-container>
</template>

<script>
  import {db, storage} from '@/firebase/init'
  import firebase from 'firebase/app'

  export default {
    props: {
      uploadOptionProp: {
        type: String
      }
    },
    watch: {
      uploadOptionProp: {
        handler (val) {
          // do your stuff
          if (val==='toWebtoon') {
            this.modalTitle = "Upload a Comic Page"
          }
          else if (val==='toGallery') {
            this.modalTitle = "Upload to Gallery"
          }
        }
      },
    },
    data: () => ({
      tags: [],
      modalTitle: null,
      file: null,
      notify: false,
      notifyHeader: "",
      notifyMessage: "",
      pages: {
        pageNum: null,
        imgURL: null,
        dateAdded: null,
        comments: [],
      }, 
      illustration: {
        // title: null,
        imgURL: null,
        tags: [],
        dateAdded: null
      },
      chapters: {
        // title: null,
        pages: [],
        numPages: 0,
        dateAdded: null
      },
      newChapterNum: 0,
      newChapterTitle: '',
      selected: "", //'Chapter 2', // must be changed to latest chapter var
                             // var selected can be used for querying
      options: [],/*[ // Populate this programatically with chapter in descending order w/ the following format.
          { value: 'Chapter 2', text: 'Chapter 2' }, // Default: latest chapter
          { value: 'Chapter 1', text: 'Chapter 1' },
          { value: 'latest chapter num + 1', text: 'New chapter...' },
        ]*/
      progress: 0,
      showOverlay: false,
      selectedBanner: "",
      optionsBanner: [
      ], /* Format(?): num: , imgUrl:  */
      newBannerFile: null,
      selectedBannerLabel: null,
      newBannerLabel: null
    }),
    computed: {
      uploadProgress() {
        return "" + this.progress + "%"
      },
      uploadBtnChecker(){
        if(!this.file)
          return false;
        else if(this.file.type != 'image/png' && this.file.type != 'image/jpeg')
          return false;
        else if(this.file.size > (20*1024*1024))
          return false;
        else if(this.selectedBanner == 'New Banner' && !this.newBannerFile)
          return false;
        else if(this.selectedBanner == 'New Banner' && this.newBannerFile.type != 'image/png' && this.newBannerFile.type != 'image/jpeg')
          return false;
        else if(this.selectedBanner == 'New Banner' && this.newBannerFile.size > (20*1024*1024))
          return false;
        else
          return true;
      },
    },
    methods: {
      // handles hide of modal for both evt.trigger backdrop/headerClose
      onHide(evt) {
        if (evt.trigger === "backdrop" || evt.trigger === "headerclose") {
          this.tags = null;
        }
      },
      onSubmit(bvModalEvt) {
        // modify this function using the info from this.uploadOptionProp 
        if(this.file == null){
          bvModalEvt.preventDefault();
          alert('No file chosen');
          // console.log('No file chosen');
        }
        //else if a file was chosen, check if the extension is of valid type
        else{
          var file = this.file;
          var fileExt = '.' + file.name.split('.').pop();
           if ((fileExt.localeCompare('.jpg') ==0)){
            // console.log(fileExt + "is jpg");
           }
           else if(fileExt.localeCompare('.png') ==0){
            //  console.log(fileExt + "is png");
           }
          
          //if the file type is valid
          if ((fileExt.localeCompare('.jpg') ==0) || (fileExt.localeCompare('.png') ==0)){
             
             //check if file size is invalid
             if (file.size > 20 * 1024 * 1024) {
               bvModalEvt.preventDefault();
               alert('File too big (> 5MB)');
              //  console.log('file greater than 5 mb')
              }
            else{
              bvModalEvt.preventDefault();
              this.showOverlay = true;
              if(this.modalTitle == "Upload a Comic Page")
              // upload comic page
                this.createNewPage();
              else
              // upload illustration
                this.createNewIllustration();
            }
          }
          //if it is valid create a new page
          //else alert
          else{
            bvModalEvt.preventDefault();
            alert('File type is incorrect');
            // console.log('File type is incorrect')
          }
        }
      },
      setUploadProgress(newVal) {
        this.progress = newVal;
      },
      createNewPage() {  
        if (this.$refs.pageForm) {
          //declare a pagedoc
          var pageDoc;
          //get the details
          var timestamp = firebase.firestore.FieldValue.serverTimestamp();
          this.pages.dateAdded = timestamp;

          //create a chapter id variable for later assignment
          var chapter_id;
          //declare a chapter doc var as the parentDoc
          var parentDoc;

          //if the selected value is a new chapter we create a new Chapter
          if(this.selected.localeCompare("New Chapter") == 0){
            var chapterBanner = "default";
            if(this.selectedBannerLabel){
              chapterBanner = this.selectedBannerLabel;
            }
            //we create a new chapter
            chapter_id = "chapter"+this.options.length;
            parentDoc = db.collection("comics").doc(chapter_id).set({
              chapterNum: Number(this.newChapterNum),
              title: this.newChapterTitle,
              dateAdded: timestamp,
              numPages: 0,
              // CHAPTER-SPECIFIC BANNER
              bannerLabel: chapterBanner
            }).then(()=>{
              this.updateChapterWithNewBanner(chapter_id)
            })
            // console.log("creating new chapter: "+ this.selected);
          }
          else{
            //concat chapter with the selected chapter number to create the id
            chapter_id = this.selected
            parentDoc = db.collection("comics").doc(chapter_id);
            // console.log("adding to previous chapter: " + this.selected);
          }

          //variables for later assignment
          var pagenum;
          var currChapterNum;

          //add the page
          db.collection("comics").doc(chapter_id).get().then((doc)=>{
            //get the numPages data
            this.pages.pageNum = doc.data().numPages;
            //assign it
            pagenum = this.pages.pageNum;
            
            currChapterNum = doc.data().chapterNum;

            //increment page num
            pagenum+=1;
            pageDoc = db.collection("comics").doc(chapter_id).collection("pages").doc();
          }).then(()=>{
              //update the parentdoc with the new pagenum
              parentDoc = db.collection("comics").doc(chapter_id)
              // console.log("parent doc: " + parentDoc.id);
              parentDoc.update({
                numPages: pagenum
              })
              .then(()=>{
                pageDoc.set({
                chapterNum: currChapterNum,
                pageNum: pagenum,
                dateAdded: this.pages.dateAdded,
                comments: []
              })
              .then(() => {
              // Upload image
                if (this.files !== null) {
                  this.putImage(parentDoc.id, pageDoc.id, this.file, pagenum); 
              } 
                //if user wants to notify subs
                if(this.notify == true){
                  db.collection("updateEmail").doc(this.notifyHeader).set({
                    message: this.notifyMessage,
                    subject: this.notifyHeader
                  }).then(()=>{
                    // console.log("Sending Email");
                  }).catch(err=>{
                    // console.log("Error sending email");
                    console.log(err);
                  })
                }
              })
              .catch(function(error) {
                throw error;
             });
            })
              
          })
          
        }
      },
      createNewChapter(){
        if (this.$refs.uploadForm.validate()) {
          var parentDoc = db.collection("comics").doc();
          var timestamp = firebase.firestore.FieldValue.serverTimestamp();
          this.chapters.dateAdded = timestamp;
          parentDoc.set({
          title: this.chapters.title,
          dateAdded: this.chapters.dateAdded
          }).then(() => {
              this.reloadPage()
            })
            .catch(function(error) {
              throw error;
            });
        }
      },
      reloadPage() {
        // window.location.assign("http://localhost:8080/");
        window.location.href = window.location.origin + '/#/archives'
        window.location.reload()
      },
      renameFile(oldFilename, newFilename){
        var fileExt = oldFilename.split('.').pop();
        return newFilename + '.' + fileExt;
      },

      createNewIllustration(){
        // add to db
        this.illustration.tags = this.tags;
        var parentDoc = db.collection("illustrations").doc();
          var timestamp = firebase.firestore.FieldValue.serverTimestamp();
          parentDoc.set({
          // title: this.illustration.title,
          tags: this.illustration.tags,
          // URL: this.illustration.imgURL,
          dateAdded: timestamp
          }).then(() => {
              if(this.file !== null){
                // console.log("Unique Illus ID: " + parentDoc.id)
                this.putIllustration(parentDoc.id, this.file)
              }
              //if user wants to notify subs
                if(this.notify == true){
                  db.collection("updateEmail").doc(this.notifyHeader).set({
                    message: this.notifyMessage,
                    subject: this.notifyHeader
                  }).then(()=>{
                    // console.log("Sending Email");
                  }).catch(err=>{
                    // console.log("Error sending email");
                    console.log(err);
                  })
                }
            })
            .catch(function(error) {
              throw error;
            });

      },
      putIllustration(doc_id, file){
        // Create storage ref
        var storageRef = storage.ref(); 
        var uploadTask = storageRef.child(`illustrations/${doc_id}/${file.name}`).put(file);
        var that = this;

        uploadTask.on('state_changed', function(snapshot){
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var p =  Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          that.setUploadProgress(p);
          // console.log(this.progress);
        }, function(error) {
          // Handle unsuccessful uploads
          throw "One image upload failed " + error;
        }, function() {
          // makes a query for the image link and updates the link field for the page
          var spaceRef = storageRef.child(`illustrations/${doc_id}/${file.name}`);
          spaceRef.getDownloadURL().then(url => {
            // console.log('getting image url')

            db.collection('illustrations')
              .doc(doc_id)
              .update({"link": url})
              .then(()=>{
                that.reloadPage()
              })
            that.file=null;
            // console.log("Upload Success!")
          })
          .catch(function(error) {
            throw "Error in retrieving download URL: " + error;
          });
        });
      },
      putImage(chapter_id, page_id, file) { // PUT one image to db
        // Create storage ref
        var storageRef = storage.ref(); 
        var uploadTask = storageRef.child(`comics/${chapter_id}/${page_id}/${file.name}`).put(file);
        var that = this;
        
        uploadTask.on('state_changed', function(snapshot){
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var p =  Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          that.setUploadProgress(p);
          // console.log(this.progress);
        }, function(error) {
          // Handle unsuccessful uploads
          throw "One image upload failed " + error;
        }, function() {

          // makes a query for the image link and updates the link field for the page
          var spaceRef = storageRef.child(`comics/${chapter_id}/${page_id}/${file.name}`);
          spaceRef.getDownloadURL().then(url => {
            // console.log('getting image url')
            var linkThumb = url.slice(0,url.lastIndexOf(page_id)+page_id.toString().length+3) + "thumb_" + url.slice(url.lastIndexOf(page_id)+page_id.toString().length+3)
            var linkResize = url.slice(0,url.lastIndexOf(page_id)+page_id.toString().length+3) + "resize_" + url.slice(url.lastIndexOf(page_id)+page_id.toString().length+3)
            db.collection('comics')
              .doc(chapter_id)
              .collection('pages')
              .doc(page_id)
              .update({"link": url, "link_thumb": linkThumb, "link_resize": linkResize})
              .then(()=>{
                that.reloadPage()
              })
            that.file=null;
            // console.log("Upload Success!")
          })
          .catch(function(error) {
            throw "Error in retrieving download URL: " + error;
          });
        });
      },
      queryChapterCollection(){
        //query the db for all chapters in desc. order
        db.collection('comics')
        .orderBy("dateAdded", "desc")
        .get()
        .then(docs =>{
          // console.log(docs)
          docs.forEach(doc => {
            //retrieve the chapter num of the document
            var chapterNum = doc.data().chapterNum;
            // console.log("chapnum:")
            // console.log(doc.data().chapterNum)
            //concatenate with chapter
            var s = "Chapter " + chapterNum;
            var object = {value: doc.id, text: s}
            this.options.push(object);
            this.setSelected(); 
          });
        }).then(()=>{
          //then push the new chapter option at the end
          var object = {value: "New Chapter", text:"New Chapter"};
          this.options.push(object);
        })
        .catch(err=>{
          throw err;
        })
      },
      setSelected(){
         //set selected to first chapter retrieved
        // console.log(this.options[0].text + "here");
        this.selected = this.options[0].value;
        // console.log("Selected changed: " + this.selected);
      },
      errorMessage(){
        var errorString = '';
        if(!this.file)
          errorString += "This field is required! ";
        else{
          if(this.file.type != 'image/png' && this.file.type != 'image/jpeg')
            errorString += "Invalid file type! Please upload only .jpg, .jpeg, or .png files.";
          if(this.file.size > (20*1024*1024))
            errorString += " File is too big!";
        }
        return errorString;
      }, 
      // Please double check this!
      fileChecker(){
        // console.log(this.file)
        if(!this.file)
          return false;
        else if(this.file.type != 'image/png' && this.file.type != 'image/jpeg')
          return false;
        else if(this.file.size > (20*1024*1024))
          return false;
        else
          return true;
      },
      bannerFileChecker(){
        // console.log(this.newBannerfile)
        if(!this.newBannerfile)
          return false;
        else if(this.newBannerfile.type != 'image/png' && this.newBannerfile.type != 'image/jpeg')
          return false;
        else if(this.newBannerfile.size > (20*1024*1024))
          return false;
        else
          return true;
      },
      bannerErrorMessage(){
        var errorString = '';
        if(!this.newBannerFile)
          errorString += "This field is required! ";
        else{
          if(this.newBannerFile.type != 'image/png' && this.newBannerFile.type != 'image/jpeg')
            errorString += "Invalid file type! Please upload only .jpg, .jpeg, or .png files.";
          if(this.newBannerFile.size > (20*1024*1024))
            errorString += " File is too big!";
        }
        return errorString;
      },
      queryBanners(){
        /* Format(?): num: , imgUrl:  */
        this.optionsBanner = []
        
        db.collection("banners")
        .get()
        .then((docs) => {
          docs.forEach((doc)=>{
            var banner = {
              name: null,
              imgUrl: null
            }
            banner.name = doc.id
            banner.imgUrl = doc.data().url
            this.optionsBanner.push(banner)
          })
        }).catch((err)=>{
          throw err;
        })
      },
      setDefaultBanner(){
        db.collection("banners")
        .doc("default")
        .get()
        .then((doc) => {
          if(doc){
            this.selectedBanner = doc.data().url
          }
        }).catch((err)=>{
          throw err;
        })
      },
      putBannerImage(banner_label, file) { // PUT one banner image to db
        // Create storage ref
        var storageRef = storage.ref(); 
        var uploadTask = storageRef.child(`banners/${banner_label}/${file.name}`).put(file);
        var that = this;
        
        uploadTask.on('state_changed', function(snapshot){
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          // var p =  
          Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          // console.log("uploading banner..." + p);
          // that.setUploadProgress(p);
          // console.log(this.progress);
        }, function(error) {
          // Handle unsuccessful uploads
          throw "One image upload failed " + error;
        }, 
        function() {
          // makes a query for the image link and updates the link field for the page
          var spaceRef = storageRef.child(`banners/${banner_label}/${file.name}`);
          spaceRef.getDownloadURL().then(bannerURL => {
            // console.log('getting image url')
            db.collection("banners").doc(banner_label).set({
             url: bannerURL
            })
            that.file=null;
            // console.log("Upload Success!");
            // this.reloadPage()
          })
          .catch(function(error) {
            throw "Error in retrieving download URL: " + error;
          });
        });
      },
    updateChapterWithNewBanner(chapterid){
      // upload banner in db and update chapter banner label
      if(this.newBannerFile && this.newBannerLabel){
        db.collection("comics")
          .doc(chapterid)
          .update({
            bannerLabel: this.newBannerLabel
        }).then(()=>{
          this.putBannerImage(this.newBannerLabel, this.newBannerFile)
        })
      }
      else{
        // update banner from newly selected
        if (this.selectedBannerLabel){
          db.collection("comics")
          .doc(chapterid)
          .update({
            bannerLabel: this.selectedBannerLabel
          })
        }
      }
    },

    },
    created(){
      this.queryChapterCollection()
      this.queryBanners()
      this.setDefaultBanner()
    },
  }
</script>

<style scoped>

.bannerSelectOption{
  max-width: 100%;
  max-height: 100%;
}
</style>
